import AdminLayout from "../../../components/layouts/admin";
import { Outlet } from "react-router";
import { Home } from "./home";
import RequireAuth from "../../../routes/requireAuth";
import { Dashboard } from "./dashboard";

export const adminRouteList = [
  {
    path: "/",
    element: (
      <AdminLayout>
        <RequireAuth allowedRoles={["ROLE_ADMIN"]}>
          <Outlet />
        </RequireAuth>
      </AdminLayout>
    ),
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
    ],
  },
];
